import useSWR from 'swr'

import { FetchError } from '../../../../data/fetchError'
import { FetchResponse } from '../../../../data/fetchResponse'
import { FetchResult } from '../../../../data/fetchResult'
import { fetchJson } from '../../../../data/fetchers'
import { EInvoiceConfig, GeneralSettings } from './model'

// Get general settings
export function useGeneralSettings(): FetchResult<GeneralSettings> {
  const { data, error, isLoading, mutate } = useSWR<
    FetchResponse<GeneralSettings>,
    FetchError
  >('/selfservices/generalsettings', fetchJson<GeneralSettings>)

  return {
    data: data?.body,
    isLoading,
    error,
    mutate,
  }
}

// Get e-invoice config
export function useEInvoiceConfig(): FetchResult<EInvoiceConfig> {
  const { data, error, isLoading, mutate } = useSWR<
    FetchResponse<EInvoiceConfig>,
    FetchError
  >('/selfservices/einvoice', fetchJson<EInvoiceConfig>)

  return {
    data: data?.body,
    isLoading,
    error,
    mutate,
  }
}
